module.exports = __webpack_public_path__ + "static/media/LATINS-facade-arriere.5b827d79.jpg";